<script setup lang="ts">
    import { Card, CardContent } from '@/components/ui/card';
    import NoCompany from '@/components/icons/NoCompany.vue';
</script>

<template>
    <Card class="m-1.5 min-h-0 flex-1">
        <CardContent class="flex h-full flex-col items-center justify-center">
            <NoCompany className="text-muted-foreground size-26" />
            <span class="text-muted-foreground">
                {{ $t('datatables.no_company') }}
            </span>
        </CardContent>
    </Card>
</template>
